import DetailVideoPlayer from './DetailVideoPlayer'

export default DetailVideoPlayer
// eslint-disable-next-line import/export
export * from './DetailVideoPlayer'
